import React, { useContext, useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useNavigate } from "react-router";
import M from "materialize-css";
import { logOut } from "../../config/ConfigFirebase";
import { AuthContext } from "../../auth/authContext";
import { types } from "../../types/type";
import { getCompanyData, getLicenciesByCompany } from "../../helpers/homeFunc";
import { CircleGif } from "../CircleGif";
import Swal from "sweetalert2";

import { getLastPanicMessage } from "../../helpers/panicMessageFunc";

export const Navbar = () => {
  //get info del useContext user information
  const navigate = useNavigate();
  const { currentUser, dispatch } = useContext(AuthContext);
  const [companyName, companySetState] = useState({ nombreCompany: "Advan" });

  const [mostrarImagen, setMostrarImagen] = useState(true);

  const [lastPanicMessage, setlastPanicMessage] = useState({
    id:0, 
    idCompany:'', 
    email:'', 
    message:'', 
    typeSinister:0, 
    dateSinister:'', 
    latitude:0.0, 
    longitude:0.0, 
    carPlates:'', 
    vehicleNumber:''
  });
  const [showModal, setShowModal] = useState(false);
  const [verMapa, setVerMapa] = useState(false);
  const [latitud, setLatitud] = useState(0);
  const [longitud, setLongitud] = useState(0);


  getLastPanicMessage(currentUser.idCompany)
  .then((result) => {
    const respuesta = JSON.stringify(result);
    console.log("Respuesta=>" + respuesta);
    if (respuesta == '[]') {
      setMostrarImagen(false);
    } else {
      setMostrarImagen(true);
    }
  });



  useEffect(() => {
    let dropnav = document.querySelectorAll(".dropdown-trigger");
    var elems = document.querySelectorAll(".sidenav");
    let zoomImgs = document.querySelectorAll(".materialboxed");

    M.Materialbox.init(zoomImgs);
    M.Dropdown.init(dropnav);
    M.Sidenav.init(elems);

    getCompanyData(currentUser.idCompany).then((result) => {
      console.log("Compañia => ", result);
      companySetState({ nombreCompany: result });
    });

  }, []);

  const { nombreCompany } = companyName;
  console.log(nombreCompany);

  //LOGOUT
  const heandlerLogOut = async () => {
    //POR HACER
    console.log("logout");

    await logOut();

    dispatch({
      type: types.logout,
    });

    navigate("/login", {
      replace: true,
    });
  };

  const handlerShowLicences = async (e) => {
    e.preventDefault();
    let licences = {};
    getLicenciesByCompany(currentUser.idCompany).then((res) => {
      licences = res;
      console.log("Licences ", licences);
      if (licences !== null) {
        Swal.fire({
          title: "<strong>Licencias</strong>",
          // icon:'info',
          showCloseButton: true,
          html:
            '<div className="center"><img  src="/assets/logoNew.png"  className="licenciaLog" style="width:200px" }}/></div>' +
            '<div className="center"><h5>DriveLog</h5></div>' +
            '<table className="striped highlight  responsive-table centered tableFont">' +
            "<tbody>" +
            "<tr><td>Licencias Web:</td><td><strong>" +
            licences.web_contratadas +
            "</strong></td></tr>" +
            "<tr><td>Consumidas Web:</td><td><strong>" +
            licences.web_consumidas +
            "</strong></td></tr>" +
            "<tr><td>Licencias App:</td><td><strong>" +
            licences.app_contratadas +
            "</strong></td></tr>" +
            "<tr><td>Consumidas App:</td><td><strong>" +
            licences.app_consumidad +
            "</strong></td></tr>" +
            "</tbody>" +
            "</table>",
        });
      }
    });
  };

  const getPanicMessage = () => {
    getLastPanicMessage(currentUser.idCompany)
    .then((result) => {
      const dataLastPanicMessage = JSON.stringify(result);
      const parseLastPanicMessage = JSON.parse(dataLastPanicMessage);
      let longResult = 0;
      if (Array.isArray(parseLastPanicMessage)) {
        longResult = parseLastPanicMessage.length;
      }
      
      if (longResult > 0) {
      setlastPanicMessage(
        {
          id: parseLastPanicMessage[0].id,
          idCompany: parseLastPanicMessage[0].idCompany,
          email: parseLastPanicMessage[0].email,
          message: parseLastPanicMessage[0].message,
          typeSinister: parseLastPanicMessage[0].typeSinister,
          dateSinister: parseLastPanicMessage[0].dateSinister,
          latitude: parseLastPanicMessage[0].latitude,
          longitude: parseLastPanicMessage[0].longitude,
          carPlates: parseLastPanicMessage[0].carPlates,
          vehicleNumber: parseLastPanicMessage[0].vehicleNumber 
        })
      }

      // console.log("latitude=>" + lastPanicMessage.latitude);
      setShowModal(true);
      
    })

  }

  return (
    <>

      {showModal && (
          <div style={modalStyle}>
          <div style={modalContentStyle}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <tbody>
                <tr>
                  <td style={{textAlign:"center"}} colSpan={2}>
                  {lastPanicMessage.message}
                  </td>
                </tr>
                <tr>
                    <td style={cellStyle}><strong>Id</strong></td>
                    <td style={cellStyle}>{lastPanicMessage.id}</td>
                </tr>
                <tr>
                    <td style={cellStyle}><strong>Operador</strong></td>
                    <td style={cellStyle}>{lastPanicMessage.email}</td>
                </tr>
                <tr>
                    <td style={cellStyle}><strong>No. Económico</strong></td>
                    <td style={cellStyle}>{lastPanicMessage.vehicleNumber}</td>
                </tr>
                <tr>
                    <td style={cellStyle}><strong>Placas</strong></td>
                    <td style={cellStyle}>{lastPanicMessage.carPlates}</td>
                </tr>
                <tr>
                    <td style={cellStyle}><strong>Latitud</strong></td>
                    <td style={cellStyle}>{lastPanicMessage.latitude}</td>
                </tr>
                <tr>
                    <td style={cellStyle}><strong>Longitud</strong></td>
                    <td style={cellStyle}>{lastPanicMessage.longitude}</td>
                </tr>
                <tr>
                    <td style={cellStyle}><strong>Fecha</strong></td>
                    <td style={cellStyle}>{lastPanicMessage.dateSinister}</td>
                </tr>
                
              </tbody>
              </table>
              <button style={styles.boton} 
                  onClick={() => {
                      setShowModal(false);
                      const x = lastPanicMessage.latitude;
                      const y = lastPanicMessage.longitude;
                      setLatitud(x);
                      setLongitud(y);
                      setVerMapa(true)
                    }
                  }
                  >Mapa</button>

              <button style={styles.boton} 
                  onClick={() => setShowModal(false)}
                  >Cerrar</button>
          </div>
          </div>
      )}

      {verMapa && (
            <>
            <div style={styles.overlay}>
            <div style={styles.mapaContenedor}>
            <iframe
              title="Mapa"
              width="100%"
              height="100%"
              src={`https://maps.google.com/maps?q=${latitud},${longitud}&z=15&output=embed`}   
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy">
              </iframe>
              <button style={styles.cerrar} onClick={() => setVerMapa(false)}>Cerrar</button>
            </div>
            </div>
            </>
            
        )}
      
      <nav style={{ height: "200px" }} className="imgNav">
        <div className="nav-wrapper navSizeDiv" style={{ top: "33%" }}>
          <NavLink className="brand-logo" to="/">
            <div className="logoNav"></div>
            <div className="center">
              <h5>
                {nombreCompany === "Advan" ? <CircleGif /> : nombreCompany}
              </h5>
            </div>
          </NavLink>

          <NavLink to="#" data-target="mobile-demo" className="sidenav-trigger">
            <i className="material-icons">menu</i>
          </NavLink>
          <ul
            id="nav-mobile"
            className="right hide-on-med-and-down margin-right"
          >
            {currentUser.typeUser === 1 ? (
              <li>
                <NavLink to="creatUsers" id="status">
                  <span>Crear Usuarios</span>
                </NavLink>
              </li>
            ) : (
              <li></li>
            )}
            {currentUser.typeUser === 1 ? (
              <li>
                <NavLink to="createCompany" id="status">
                  <span>Crear Compañias</span>
                </NavLink>
              </li>
            ) : (
              <li></li>
            )}
            {currentUser.typeUser === 1 ? (
              <li>
                <NavLink to="status" id="status">
                  <span>Crear Status</span>
                </NavLink>
              </li>
            ) : (
              <li></li>
            )}

            {/* {currentUser.typeUser === 1 ? (
              <li>
                <NavLink to="videos" id="status">
                  <span>Subir Video</span>
                </NavLink>
              </li>
            ) : (
              <li></li>
            )} */}
            {currentUser.typeUser === 2 || currentUser.typeUser === 3 ? (
              <>
                <li>
                  <NavLink to="chat" id="chat">
                    <span>Chat</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="mapa" id="mapa">
                    Mapa
                  </NavLink>
                </li>
                <li>
                  <NavLink to="evidencias" id="evi">
                    Evidencias
                  </NavLink>
                </li>
                <li>
                  <NavLink to="incidencias" id="inc">
                    Incidencias
                  </NavLink>
                </li>
                {
                  currentUser.companyType == 'D' ?
                    <li>
                      <NavLink to="devoluciones" id="dev">
                        Devoluciones
                      </NavLink>
                    </li> : <li></li>
                }

                <li>
                  <NavLink to="bitacora" id="dev">
                    Bitácora
                  </NavLink>
                </li>

              </>
            ) : (
              <>
                <li></li>
              </>
            )}
            {currentUser.typeUser === 2 ? (
              <li>
                <NavLink to="usuarios" id="usuarios">
                  Usuarios
                </NavLink>
              </li>
            ) : (
              <li></li>
            )}
            {currentUser.typeUser === 2 ? (
              <li>
                <NavLink to="conexiones" id="conexiones">
                  Conexiones
                </NavLink>
              </li>
            ) : (
              <li></li>
            )}

            {currentUser.typeUser === 2 || currentUser.typeUser === 3 ? (
              <>
                <li>
                {mostrarImagen && (
                  <img
                      src="/assets/alerta.png"
                      alt="Icono"
                      onClick={getPanicMessage}
                      style={{ 
                        cursor: 'pointer',
                        width: '40px', 
                        height: '40px', 
                        marginRight: '8px' }}
                    />
                )}
                </li>
              </>
            ):null}



            {
              // MENU CONCEPTS
            }
            {currentUser.typeUser === 2 ? (
              <li>
                <NavLink
                  to="#"
                  className="dropdown-trigger"
                  data-target="conceptsMenu"
                >

                  <i className='material-icons menuConcepts'>menu</i>

                </NavLink>
              </li>
            ) : (
              <li></li>
            )}
            <ul id="conceptsMenu" className="dropdown-content show-ps">
              {/* <li>
                <Link to="conceptosGastos">
                  <span className="title ">Conceptos de Gastos</span>
                </Link>
              </li>
              <li className="divider"></li> */}
              <li>
                <Link to="conceptosDevolucion">
                  <span className="title ">Conceptos de Devoluciones</span>
                </Link>
              </li>
              <li className="divider"></li>

            </ul>
            {/* click user */}
            <li className="center">
              <NavLink
                to="#"
                className="dropdown-trigger"
                data-target="dropdown1"
              >
                <button className="btn-floating btn-medium">
                  <img
                    alt={currentUser.name}
                    src={
                      currentUser.image != ""
                        ? currentUser.image
                        : `/assets/marvel-thor.png`
                    }
                    className="navBarPic"
                  />
                </button>
              </NavLink>
              <span style={{ fontSize: "8.5px", textOverflow: "ellipsis" }}>
                {currentUser.email}
              </span>
              <ul id="dropdown1" className="dropdown-content show-ps">
                <li>
                  <Link to="changePassword">
                    <span className="title ">Cambiar contraseña</span>
                  </Link>
                </li>
                <li className="divider"></li>
                <li>
                  <Link to="perfil">
                    <span className="title ">Editar Perfil</span>
                  </Link>
                </li>
                <li className="divider"></li>
                <li>
                  <Link to="" onClick={heandlerLogOut}>
                    <span className="title">Cerrar Sesión</span>
                  </Link>
                </li>
                <li>
                  <Link to="" onClick={handlerShowLicences}>
                    <span className="title">Licencias</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>

      {/*SIDE NAV MObile & tablet */}
      <ul id="mobile-demo" className="sidenav">
        <li>
          <div className="user-view userViewM">
            <div className="background">
              <img src="images/office.jpg" />
            </div>
            <Link to="">
              <img
                alt={currentUser.name}
                src={
                  currentUser.image != ""
                    ? currentUser.image
                    : `/assets/marvel-thor.png`
                }
                className="circle responsive-img"
              />
            </Link>
            <span className="white-text name">{currentUser.name}</span>
            <span className="white-text email">{currentUser.email}</span>
          </div>
        </li>
        {currentUser.typeUser === 1 ? (
          <li>
            <NavLink to="creatUsers" id="status">
              <i className="material-icons ">person</i>
              <span>Crear Usuarios</span>
            </NavLink>
          </li>
        ) : (
          <li></li>
        )}
        {currentUser.typeUser === 1 ? (
          <li>
            <NavLink to="createCompany" id="status">
              <i className="material-icons ">business</i>
              <span>Crear Compañias</span>
            </NavLink>
          </li>
        ) : (
          <li></li>
        )}
        {currentUser.typeUser === 1 ? (
          <>
            <li>
              <NavLink to="status" id="status">
                <i className="material-icons ">style</i>
                <span>Crear Status</span>
              </NavLink>
            </li>
          </>
        ) : (
          <></>
        )}

        {/* {currentUser.typeUser === 1 ? (
          <>
            <li>
              <NavLink to="videos" id="status">
                <i className="material-icons ">video_library</i>
                <span>Subir Video</span>
              </NavLink>
            </li>
          </>
        ) : (
          <></>
        )} */}
        {currentUser.typeUser === 2 || currentUser.typeUser === 3 ? (
          <>
            <li>
              <NavLink to="chat" id="chat">
                <i className="material-icons ">question_answer</i>
                <span>Chat</span>
              </NavLink>
            </li>
            <li className="divider"></li>
            <li>
              <NavLink to="mapa" id="mapa">
                <i className="material-icons ">map</i>Mapa
              </NavLink>
            </li>
            <li className="divider"></li>
            <li>
              <NavLink to="evidencias" id="evi">
                <i className="material-icons ">assignment</i>Evidencias
              </NavLink>
            </li>
            <li className="divider"></li>
            <li>
              <NavLink to="incidencias" id="inc">
                <i className="material-icons ">collections</i>Incidencias
              </NavLink>
            </li>
            <li className="divider"></li>
          </>
        ) : (
          <>
            <li></li>
          </>
        )}
        {currentUser.typeUser === 2 ? (
          <li>
            <NavLink to="usuarios" id="usuarios">
              <i className="material-icons ">people</i>Usuarios
            </NavLink>
          </li>
        ) : (
          <li></li>
        )}
        <li className="divider"></li>

        <li>
          <Link to="changePassword">
            <i className="material-icons ">lock</i>Cambiar contraseña
          </Link>
        </li>
        <li className="divider"></li>
        <li>
          <Link to="perfil">
            <i className="material-icons ">person</i>Editar Perfil
          </Link>
        </li>
        <li className="divider"></li>
        <li>
          <Link to="" onClick={heandlerLogOut}>
            <i className="material-icons ">logout</i>Cerrar Sesión
          </Link>
        </li>
        <li className="divider"></li>
        <li>
          <Link to="" onClick={handlerShowLicences}>
            <span className="title">Licencias</span>
          </Link>
        </li>
      </ul>
      {/**END SIDE NAV */}
    </>
  );
};

// Estilos simples para el modal
const modalStyle = {
  position: 'fixed',
  top: 0, left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalContentStyle = {
  background: 'white',
  padding: '2rem',
  borderRadius: '10px',
  minWidth: '300px',
  textAlign: 'center',
};

const cellStyle = {
  border: '1px solid #ccc',
  padding: '8px',
};

const styles = {
  toast: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
    padding: '16px',
    zIndex: 1000,
    maxWidth: '300px',
    fontSize: '14px',
  },
  table: {
    width: '100%',
    marginTop: '10px',
  },
  boton: {
    marginTop: '10px',
    padding: '8px 12px',
    border: 'none',
    backgroundColor: '#007bff',
    color: '#fff',
    borderRadius: '5px',
    cursor: 'pointer',
    marginRight: '10px'
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 2000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  mapaContenedor: {
    width: '80%',
    height: '80%',
    backgroundColor: '#fff',
    position: 'relative',
    borderRadius: '10px',
    overflow: 'hidden',
  },
  cerrar: {
    position: 'absolute',
    top: 10,
    right: 10,
    backgroundColor: 'red',
    color: '#fff',
    padding: '5px 10px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    zIndex: 3000
  }
};